(function() {
    'use strict';

    angular
    .module('Directives')

    .directive('schedPickupModal', function() {
        return {
            restrict: 'EA',
            /*scope: {
                addTimeSlot: ='&'
            },*/
            link: function($scope, $element, $attrs) {
                
                var btnSave = $element.find('.save');
                var btnCancel = $element.find('.cancel');

                btnSave.bind('click', function(){
                     $scope.addTimeSlot();
                    $($element).modal('hide');
                });

                btnCancel.bind('click', function(){
                    $scope.cancelAddingTimeSlot();
                    $($element).modal('hide');
                });

                //btnSave.attr('ng-click', $scope.addTimeSlot);
            }
        };
    });

})();


// WEBPACK FOOTER //
// ./js/directives/sched-pickup-modal.js